module.exports = "https://venezia-network.servercdn.it/static/img/arrow_down.svg?edae75b17bb0ffb22f15c3bf2ab48fb4";